<template>
  <div>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(submitRequest)">
        <div class="breadcrumb-area pos-relative w-100">
          <h1>{{ dataRequest.id ? 'Sửa' : 'Thêm mới' }} hiện trạng Ticket</h1>

          <div style="float: right">
            <button
              type="button"
              @click="$router.push('/ticket-current-state')"
              class="btn btn-light"
            >
              Hủy bỏ
            </button>
            <button class="btn btn-success btn-primary ml-2">
              {{ dataRequest.id ? 'Lưu' : 'Thêm mới' }}
            </button>
          </div>
        </div>
        <div class="card p-10 pt-15 b-t-1-869fb229" style="overflow-x: hidden; overflow-y: auto">
          <div class="card-body px-20 row">
            <div class="col-md-6">
              <ValidationProvider rules="" vid="applyFor" name="Mã danh mục Ticket">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">
                    Mã danh mục Ticket <span style="color: red"> *</span>
                  </label>
                  <div class="col-sm-9">
                    <Select2MultipleControl
                      :settings="{ closeOnSelect: false }"
                      v-model="dataRequest.applyFor"
                      :options="dataTypeCode"
                    >
                    </Select2MultipleControl>
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|codeGroupTicket" vid="code" name="Mã hiện trạng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Mã hiện trạng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input
                      :disabled="!!dataRequest.id"
                      type="text"
                      class="form-control"
                      v-model.trim="dataRequest.code"
                      @input="toUpperCase"
                    />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="required|minMaxName_7" vid="name" name="Tên hiện trạng">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"
                    >Tên hiện trạng<span style="color: red"> *</span></label
                  >
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model.trim="dataRequest.name" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="" vid="color" name="Màu sắc">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label"> Màu sắc </label>
                  <div class="col-sm-9">
                    <Select2 v-model="dataRequest.color" :options="optionsColor" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
              <ValidationProvider rules="minMaxName_6" vid="description" name="Mô tả">
                <div class="form-group row" slot-scope="{ errors }">
                  <label class="col-sm-3 col-form-label">Mô tả</label>
                  <div class="col-sm-9">
                    <input type="text" class="form-control" v-model="dataRequest.description" />
                    <p class="text-danger">{{ errors[0] }}</p>
                  </div>
                </div>
              </ValidationProvider>
            </div>
          </div>
        </div>
      </form>
    </ValidationObserver>
    <VueLoadingOverlay :active.sync="showLoading" :is-full-page="true"></VueLoadingOverlay>
  </div>
</template>

<script>
  import { TicketService } from '@/services/ticket.service'
  import pick from 'lodash/pick'
  export default {
    name: 'ticket-current-state',
    data() {
      return {
        dataRequest: {
          applyFor: [],
          color: null,
        },
        dataTypeCode: [],
        showLoading: false,
        optionsColor: [
          { id: 'YELLOW', text: 'Màu vàng' },
          { id: 'ORANGE', text: 'Màu cam' },
          { id: 'RED', text: 'Màu đỏ' },
          { id: 'GREEN', text: 'Màu xanh lá' },
          { id: 'BLUE', text: 'Màu xanh nước biển' },
          { id: 'BLACK', text: 'Màu đen' },
          { id: 'GRAY', text: 'Màu xám' },
        ],
      }
    },
    created() {
      TicketService.fetchCategory()
        .then(s => s.data?.map(s => s.code) ?? [])
        .then(s => (this.dataTypeCode = s))
      this.fetchData()
    },
    methods: {
      async submitRequest() {
        try {
          this.showLoading = true
          let params = this.dataRequest
          if (this.dataRequest.applyFor.length < 1) {
            this.showFailMx('Mã danh mục không được để trống')
            return
          }

          if (this.dataRequest.id) {
            params = pick(this.dataRequest, ['applyFor', 'description', 'name', 'color'])
            params.id = this.$route.params.id
            const response = await TicketService.updateCurrentState(params)
            if (response.success) {
              this.showSuccessMx('Cập nhật hiện trạng ticket thành công').then(() =>
                this.$router.push('/ticket-current-state')
              )
            } else this.showFailMx(response.message)
          } else {
            const response = await TicketService.createCurrentState(params)
            if (response.success) {
              this.showSuccessMx('Thêm mới hiện trạng ticket thành công').then(() =>
                this.$router.push('/ticket-current-state')
              )
            } else this.showFailMx(response.message)
          }
        } catch (error) {
          this.showFailMx(error.message ?? error)
        } finally {
          this.showLoading = false
        }
      },
      toUpperCase() {
        this.dataRequest.code = this.dataRequest.code.toUpperCase()
        this.dataRequest.code = this.dataRequest.code.replace(/[^\w\sÀ-ỹ]/g, '')
      },
      async fetchData() {
        const actionResultId = this.$route.params.id
        if (actionResultId) {
          try {
            this.showLoading = true
            const responsive = await TicketService.getDetailCurrentState({ actionResultId })
            this.dataRequest = responsive.data
            console.log(this.dataRequest)
          } catch (error) {
            console.log(error)
          } finally {
            this.showLoading = false
          }
        }
      },
    },
  }
</script>

<style scoped></style>
